var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var SmallX = function SmallX(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 6 6' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { fill: 'currentColor', d: 'M5.25 0L3 2.25.75 0 0 .751l2.25 2.25L0 5.251.75 6 3 3.75 5.25 6l.751-.749-2.25-2.25 2.25-2.25z', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default SmallX;
//# sourceMappingURL=SmallX.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/SmallX.js